{
  "process-container": {
    "text": {
      "back-to-home": "Zurück zu Startseite",
      "page-loading": "Seite wird geladen"
    }
  }
}
